const translations = {
    ComingSoon: "Bientôt disponible",
    ContactUs: "Contact",
    FeatActivities: "Activités e-learning",
    FeatActivities_sub: "Créer, assigner et commenter des tâches.",
    FeatChat: "Blog et chats pour discuter et partager",
    FeatChat_sub:
        "Partagez et discutez du contenu avec toute la classe ou discutez en petits groupes.",
    FeatCoursePlanning: "Planification et calendrier des cours",
    FeatCoursePlanning_sub:
        "Planificateur de cours entièrement personnalisable.",
    FeatEvaluations: "Évaluations de cours",
    FeatEvaluations_sub:
        "Formulaires d'évaluation entièrement personnalisables, démarrant automatiquement.",
    FeatLinksIntegration: "Intégration des liens",
    FeatLinksIntegration_sub:
        "Profitez de belles intégrations pour les vidéos, les aperçus de sites Web, les formulaires interactifs et bien plus encore.",
    FeatMultimediaComments: "Annotation de photos, vidéos et sons",
    FeatMultimediaComments_sub:
        "Ajotzer des commentaires à un moment ou à un endroit précis. Idéal pour les analyses.",
    FeatMultimediaDocs: "Documents multimédias",
    FeatMultimediaDocs_sub:
        "Téléchargez des images, des vidéos ou des PDF, Isyflow les traitera et affichera un aperçu élégant.",
    FeatNews: "Nouvelles",
    FeatNews_sub: "Tenez facilement vos membres informés des nouvelles.",
    FeatRegistration: "Inscription aux cours",
    FeatRegistration_sub:
        "Vos étudiant.e.s peuvent s'incrire directement aux cours qui les intéressent.",
    FeatSms: "Envoi de SMS",
    FeatSms_sub:
        "Envoyez des rappels automatiques ou des messages personnalisés en cas d'événements imprévus.",
    FeatTargetedCommunication: "Communication ciblée",
    FeatTargetedCommunication_sub:
        "Envoyer des messages à tous les enseignants ou à tous les étudiants inscrits à un semestre.",
    FeatTeacherWorkspace: "Espaces de travail",
    FeatTeacherWorkspace_sub:
        "Créez un espace de travail pour chaque classe et invitez-y vos élèves.",
    Impressum: "Impressum",
    InfoPrivateRollout:
        "Isyflow est utilisé avec succès depuis 5 ans dans des établissements d'enseignement et des universités suisses et allemandes. La plateforme sera bientôt disponible pour un usage individuel.",
    Login: "Login",
    LoginOrSignup: "Login / Inscription",
    Nav_Home: "Accueil",
    Nav_Vet: "Isyflow-VET",
    Nav_Learning: "Isyflow-Learning",
    OpenAccountTrial: "Ouvrir un compte (gratuit jusqu'au 31.08.2020)",
    OrganisationFeaturesTitle: "Pour les institutions",
    Plan_Free: "GRATUIT",
    Plan_Guru: "GOUROU",
    Plan_Organisation: "Organisation",
    Plan_Pro: "PRO",
    Pricing_encoding:
        "{count} minutes de vidéo et de son téléchargées par mois",
    Pricing_featuresTeacher: "Fonctionalités pour les enseignant.e.s",
    Pricing_featuresMiniOrg:
        "Page d'accueil et hiérarchie d'espaces de travail",
    Pricing_featuresOrg: "Fonctionalités institutionelles (en option)",
    Pricing_from: "dès",
    Pricing_members: "{count} membres inclus",
    Pricing_membersAdd: "2.-/membre/mois",
    Pricing_membersUnlimited: "Membres illimités",
    Pricing_perMonth: "par mois",
    Pricing_perMonthAltern: "ou {price}.- par année",
    Pricing_perYear: "par année",
    Pricing_storage: "{count} GB de stockage",
    Pricing_storageAdd: "1.-/mo pour 10GB",
    Pricing_emailSupport: "Support par email",
    Pricing_emailSupportPriority: "Support par email prioritaire",
    Pricing_emailAndPhoneSupportPriority:
        "Support par téléphone et email prioritaire",
    Pricing_workspace: "{count} espace de travail",
    Pricing_workspaces: "{count} espaces de travail",
    Pricing_workspacesUnlimited: "Espaces de travail illimités",
    PricingTitle: "Prix",
    PrivacyPolicy: "Politique de confidentialité",
    PricingWarning:
        "Les plans individuels sont en phase de test privé et seront bientôt disponibles. Veuillez nous contacter si vous êtes intéressé-e à participer à la phase de test ou si vous souhaitez être informé-e lorsque ces plans seront disponibles.",
    Product_Learning: "Isyflow Learning",
    Product_Learning_Desc:
        "Le cockpit digital pour les enseignant.e.s et les insituttions de formation",
    Product_Vet: "Isyflow VET",
    Product_Vet_Desc: "Le cockpit digital pour la formation professionnelle",
    TeacherFeaturesTitle: "Pour les enseignant.e.s",
    Team_Dev: "Développement",
    Team_Consulting: "Conseil",
    Tutorials: "Tutoriels",
    VetFeatures: "Des fonctions complètes pour toutes les parties prenantes",
    Vet_Admin: "Gestion des cours",
    Vet_AdminDesc:
        "Les associations, les entreprises et les écoles publient des cours, reçoivent les inscriptions, consultent la liste des participants, émettent des factures, traitent le cours en face à face ou en ligne dans Isyflow et envoient automatiquement les confirmations de participation. Vous produisez des unités d'apprentissage en ligne multimédias et interactives dans Isyflow et les mettez à disposition gratuitement ou moyennant paiement.",
    Vet_LearnPlan: "Plans de formation et formulaires numériques",
    Vet_LearnPlanDesc:
        "Les associations et les Ortral mettent à disposition leurs plans d'éducation et tous les formulaires numériques pour la documentation de l'apprentissage, les évaluations et les rapports semestriels  dans une seule application dans Isyflow. Ils peuvent envoyer des nouvelles et des rappels réguliers et automatisés, organiser les examens finaux et gérer leurs évaluations.",
    Vet_SiteCoop: "Coopération entres sites de formation",
    Vet_SiteCoopDesc:
        "Les écoles et les centres de formation interentreprises peuvent utiliser des exemples pratiques dans les leçons que les apprenants ont approuvés après consultation. Ils apprennent quels apprenants ont fait ou n'ont pas fait des choses similaires dans leur entreprise et peuvent différencier ces groupes dans les cours et ainsi compléter la formation de l'entreprise de manière ciblée. Les écoles et les Üks peuvent saisir de manière visible les objectifs d'apprentissage qui ont été traités et testés pour les entreprises.",
    Vet_Situated: "Documents de formation situés",
    Vet_SituatedDesc:
        "Les écoles et les cours interentreprises attribuent les matériels de formation aux situations. Si nécessaire, les formateurs professionnels relient ces exercices et ce matériel d'apprentissage à leurs apprenants et reçoivent un message lorsqu'ils ont été travaillés.",
    Vet_Skills: "Compétences et situations",
    Vet_SkillsDesc:
        "Les formateurs professionnels reçoivent un message lorsqu'un retour d'information est nécessaire sur une évaluation ou un document d'apprentissage. Les situations de travail documentées des apprenants sont liées aux compétences ou aux situations des plans de formation. Cela permet d'obtenir une image claire des progrès réalisés. En outre, le développement personnel (organisation du travail, flexibilité, etc.) est enregistré et peut être discuté au fil du temps.",
    VetFeat_Oda: "Association professionnelle, Ortra",
    VetFeat_Oda_0: "Saisit les plans de formation",
    VetFeat_Oda_1:
        "Fournit des formulaires pour les évaluations, la documentation d'apprentissage, les rapports semestriels.",
    VetFeat_Oda_2:
        "Organise la formation continue et les cours : Annonce, inscription, liste des participants, documents, etc.",
    VetFeat_Oda_3:
        "Crée des unités d'apprentissage en ligne : multimédia et interactives, avec des simulations intégrées.",
    VetFeat_Oda_4: "Fournit des documents de formation prêts à être imprimés",
    VetFeat_Oda_5: "Organise les examens et gère les évaluations",
    VetFeat_Comp: "Entreprises et superviseurs",
    VetFeat_Comp_0:
        "Automatisent les processus administratifs et utilisent la plateforme pour leurs propres documents",
    VetFeat_Comp_1:
        "Disposent d'un cockpit avec le niveau de formation et le développement de la personnalité de tous les apprenants",
    VetFeat_Comp_2:
        "Complètent en ligne la documentation sur l'apprentissage, l'évaluation et le rapport semestriel.",
    VetFeat_Comp_3:
        "Recevoivent une notification lorsqu'un feedback est attendu",
    VetFeat_Comp_4:
        "Classent leurs documents tels que les instructions, les processus ou les informations sur les produits",
    VetFeat_Comp_5:
        "Envoient des nouvelles à tous les apprenants ou formateurs",
    VetFeat_School: "Écoles et cours interentreprises",
    VetFeat_School_0:
        "Sont connetés avec les entreprises entreprises ou utilisent Isyflow comme plateforme de formation.",
    VetFeat_School_1:
        "Saisissent les objectifs d'apprentissage couverts pour informer la pratique",
    VetFeat_School_2:
        "Mettent du matériel et des exercices à disposition de la pratique",
    VetFeat_School_3: "Obtiennent des exemples tirés de la pratique",
    VetFeat_Stud: "Apprenants",
    VetFeat_Stud_0:
        "Documentent leurs expériences avec leur smartphone, ont accès à des exercices personnalisés, reçoivent des rappels des tâches à effectuer et des échéances.",
    VetFeat_Stud_1:
        "Remplissent des rapports et des formulaires d’évaluation, reçoivent des feedbacks",
    VetFeat_Stud_2: "Ont accès à un chat protégé avec leurs superviseurs",
    VetFeat_Stud_3:
        "Constantine leurs progrès professionnels et leur développement personnel",
    VetFeat_Stud_4:
        "Fournissent des exemples pratiques aux centres de formation et aux écoles",
    VetFeat_Stud_5:
        "Utilisent leur profil de compétences pour leurs postulations",
    VetFeat_Stud_6:
        "Participent à des formations continues et reçoivent des propositions de formation continue",
    VetFeat_Admin: "Administration (*)",
    VetFeat_Admin_0:
        "Envoie newsletters aux apprenants, aux écoles et aux entreprises.",
    VetFeat_Admin_1: "Saisit les plans de formation",
    VetFeat_Admin_2:
        "Crée des espaces de travail ou d'apprentissage et des chats pour les groupes de projet et les cours",
    VetFeat_Admin_3: "Rassemble les informations dans des cockpits",
    VetFeat_Admin_4:
        "Crée des formulaires pour la documentation de l'apprentissage, les rapports semestriels, les évaluations et pour le suivi du développement personnel",
    VetFeat_Admin_5:
        "Enregistre les documents de formation et les affecte aux objectifs et aux situations de formation",
    VetFeat_Admin_6: "Crée des unités d'apprentissage en ligne (*)",
    VetFeat_Admin_7:
        "Créer des cours, y compris l'inscription, la mise en œuvre et la facturation (*)",
    VetFeat_Admin_8:
        "Configure l'authentification unique (Single-Sign-On) et l'intégration avec les plateformes existantes telles que Microsoft Teams ou Moodle. (*)",
    VetPrice_1: "40.- par apprenant pour toute la durée de la formation",
    VetPrice_1_1:
        "De 250 à 2000 nouveaux contrats d'apprentissage par an, puis prix gradués",
    VetPrice_2:
        "28.- pour continuer à utiliser la plateforme après la formation",
    VetPrice_2_1:
        "En tant que documentation d'apprentissage tout au long de la vie, portfolio d’expérience professionnelle et suivi des formations continues",
    VetPrice_3: "10.- supplémentaires pour les fonctions marquées d'une (*)",
    WelcomeTitle: "La plate-forme d'apprentissage pour l'ère numérique.",
    WelcomeSubtitle:
        "Isyflow est une plate-forme en ligne qui offre des outils de communication, de collaboration et de gestion faciles à utiliser et efficaces pour les enseignant.e.s et les institutions de formation innovants."
};

export default translations;
